import AddressHash from '@/components/AddressHash'
import styles from './index.module.less'
import classNames from 'classnames'
import Img_right from '@/assets/image/gea/cheveron-right.svg'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Transaction } from '@/api/transactionList/interface'
import {
  getSendMsgTag,
  getTermsDay,
  getTransactionType,
  SendMsgTagArray,
} from '@/views/Transaction/utils'
import { ugagToGag, ugeaToGea2, ugeaToGea3 } from '@/utils/number'
import { getFormatTimeZone, isEmptyOrNil } from '@/utils'
import useMeNavigate from '@/hooks/useMeNavigate'
import { useParams } from 'react-router-dom'

function sumInterests(data: any, fields: string[]) {
  // 定义需要处理的字段列表

  let sum = 0

  fields.forEach((field) => {
    // 检查字段是否存在且有值
    if (data[field] !== undefined && data[field] !== null && data[field] !== '') {
      let value = data[field]

      // 如果值是字符串且包含"ugea"，则移除"ugea"
      if (typeof value === 'string' && value.includes('ugea')) {
        value = value.replace(/ugea/g, '')
      }
      // 尝试将值转换为数字
      const num = parseFloat(value)

      // 如果转换成功且不是NaN，则加到总和中
      if (!isNaN(num)) {
        sum += num
      }
    }
  })
  return sum
}

const TransactionListCardInfo = ({ cardData }: { cardData: Transaction }) => {
  const { t } = useTranslation()
  const typeElement = useRef<HTMLDivElement>(null)
  const [amountHeight, setAmountHeight] = useState<number>(0)
  const [amountUnit, setAmountUnit] = useState<string>('GEA')
  const pageTitleFormat = useMemo(() => {
    const type = cardData?.msgs?.[0]?.type || cardData?.msgs?.[0]?.type || ''
    if (type === 'cosmos.bank.v1beta1.MsgSend') {
      const tag = cardData?.tag || ''
      if (SendMsgTagArray.includes(tag)) {
        return getSendMsgTag(tag, t)
      }
    }
    // AGE (CHN Node) 质押（存入） gea.staking.MsgCreateLockUpDelegate
    // AGE (CHN Node) 质押赎回 gea.staking.MsgReduceLockUpDelegation
    // AGD (CHN Node) 节点质押取回 gea.staking.MsgUnDelegate
    // AGD (CHN Node) 质押(存入) gea.staking.MsgCreateDelegate
    // AGS（{{ regionId }}  Node ）质押（{{ term }} 天） gea.staking.MsgCreateFixedDelegation
    // AGS（{{ regionId }} Node）赎回 gea.staking.MsgWithdrawFixedDelegation
    // AGE ({{ regionId }} Node)提取锁仓奖励 gea.staking.MsgWithdrawLockUpReward
    const pageTitle = getTransactionType(type)?.pageTitle
    let node = ''
    if (
      [
        'gea.staking.MsgReduceLockUpDelegation',
        'gea.staking.MsgCreateLockUpDelegate',
        'gea.staking.MsgUnDelegate',
        'gea.staking.MsgCreateDelegate',
        'gea.staking.MsgCreateFixedDelegation',
        'gea.staking.MsgWithdrawFixedDelegation',
        'gea.staking.MsgWithdrawLockUpReward',
      ].includes(type)
    ) {
      node = cardData?.msgs?.[0]?.extra_info?.region_id || '-'
      let term = cardData?.msgs?.[0]?.extra_info?.term || '-'
      node = node.toLocaleUpperCase()
      if (node.endsWith('_VILLAGE')) {
        node = node.replace('_VILLAGE', '').toLocaleLowerCase()
        node = node.charAt(0).toUpperCase() + node.slice(1)
      }
      const replacedText = pageTitle.replace(
        /\{\{(.*?)\}\}/g, // 匹配 {{ ... }}
        (match: any, content: any) => {
          if (/regionId/.test(content)) {
            return node // {{ ... regionId ... }} → aa
          } else if (/term/.test(content)) {
            return getTermsDay(term) // {{ ... term ... }} → bb
          }
          return match // 其他情况保持不变
        },
      )
      if (node === '-' && replacedText.includes('Node')) {
        const newPageTitle = replacedText.replace(/(\s*Node\s*)/, '')
        return newPageTitle
      }
      return replacedText
    }
    return pageTitle
  }, [cardData])

  const navigate = useMeNavigate()
  const [isFold, setIsFold] = useState(true)

  const { timeUtc0 = '-', currentTime = '-' } = getFormatTimeZone(cardData?.time?.timestamp)

  const handleSetIsFold = () => {
    setIsFold(!isFold)
  }

  const getDisplayChild = (type: string | undefined) => {
    const emptyData = {
      childType: null,
      isShowTypeSword: false,
      childAmount: null,
      isShowAmountSword: false,
    }
    if (!type) {
      return emptyData
    }
    // gea.kyc.MsgUpdate 更新kyc
    if (type === 'gea.kyc.MsgUpdate') {
      // 有interest 代表有AGD更新区
      const interest = cardData?.msgs?.[0]?.extra_info?.interest
      if (interest) {
        const childType = (
          <div
            className={classNames({
              [styles.redundantBox]: true,
              [styles.isHidden]: isFold,
            })}
          >
            <div className={classNames(styles.textStyleTwo, 'font_14')}>{t('explorer_234')}</div>
            <div className={classNames(styles.textStyleTwo, 'font_14')}>{t('explorer_234')}</div>
          </div>
        )
        const childAmount = (
          <div
            className={classNames({
              [styles.redundantBox]: true,
              [styles.isHidden]: isFold,
            })}
          >
            <div
              className={classNames(styles.textStyleTwo, 'font_14', {
                [styles.childType_height_nowrap_mobile]: false,
              })}
            >
              <span>{ugeaToGea2(interest).value}</span>{' '}
              <span className={classNames(styles.textStyleThree, 'font_14')}>
                {ugeaToGea2(interest).value !== '-' ? 'GEA' : ''}
              </span>
            </div>
            <div
              className={classNames(styles.textStyleTwo, 'font_14', {
                [styles.childType_height_nowrap_mobile]: false,
              })}
            >
              <span>{ugagToGag(interest).value}</span>{' '}
              <span className={classNames(styles.textStyleThree, 'font_14')}>
                {ugagToGag(interest).value !== '-' ? 'GAG' : ''}
              </span>
            </div>
          </div>
        )
        return {
          childType,
          isShowTypeSword: true,
          childAmount,
        }
      }
      return emptyData
    } else if (type === 'gea.staking.MsgSwap') {
      // gea.staking.MsgSwap 置换
      let out_amount: any = cardData?.msgs?.[0]?.extra_info?.out_amount //兑换
      let in_amount: any = cardData?.msgs?.[0]?.extra_info?.in_amount //获得
      if (out_amount?.includes('ugea')) {
        out_amount = ugeaToGea2(out_amount)
      } else {
        out_amount = ugagToGag(out_amount)
      }
      if (in_amount?.includes('ugea')) {
        in_amount = ugeaToGea2(in_amount)
      } else {
        in_amount = ugagToGag(in_amount)
      }

      const childType = (
        <div
          className={classNames({
            [styles.redundantBox]: true,
            [styles.isHidden]: isFold,
          })}
        >
          {/* 兑换 */}
          <div className={classNames(styles.textStyleTwo, 'font_14')}>{t('explorer_235')}</div>
          {/* 获得 */}
          <div className={classNames(styles.textStyleTwo, 'font_14')}>{t('explorer_236')}</div>
        </div>
      )

      const childAmount = (
        <div
          className={classNames({
            [styles.redundantBox]: true,
            [styles.isHidden]: isFold,
          })}
        >
          <div
            className={classNames(styles.textStyleTwo, 'font_14', {
              [styles.childType_height_nowrap_mobile]: false,
            })}
          >
            <span>{in_amount.value}</span>{' '}
            <span className={classNames(styles.textStyleThree, 'font_14')}>{in_amount.sigin}</span>
          </div>
          <div
            className={classNames(styles.textStyleTwo, 'font_14', {
              [styles.childType_height_nowrap_mobile]: false,
            })}
          >
            <span>{out_amount.value}</span>{' '}
            <span className={classNames(styles.textStyleThree, 'font_14')}>{out_amount.sigin}</span>
          </div>
        </div>
      )
      return {
        childType,
        isShowTypeSword: true,
        childAmount,
      }
    } else if (
      [
        'gea.staking.MsgReduceLockUpDelegation',
        'gea.staking.MsgUnDelegate',
        'gea.staking.MsgCreateFixedDelegation',
        'gea.staking.MsgTransferRegion',
        'gea.staking.MsgKycUsersTransferToNewRegion',
        'gea.staking.MsgCreateLockUpDelegate',
        'gea.staking.MsgWithdrawFixedDelegation',
        'gea.staking.MsgCreateDelegate',
      ].includes(type)
    ) {
      // AGS (CHN Node) 质押（30）天
      // AGD (CHN Node) 节点质押取回 gea.staking.MsgUnDelegate
      // AGE (CHN Node) 质押赎回 gea.staking.MsgReduceLockUpDelegation
      // 转区申请 gea.staking.MsgTransferRegion
      // 用户转区 gea.staking.MsgKycUsersTransferToNewRegion
      // AGE (CHN Node) 质押（存入）  gea.staking.MsgCreateLockUpDelegate
      // AGS (CHN Node) 质押赎回 gea.staking.MsgWithdrawFixedDelegation
      // AGD 质押(存入) gea.staking.MsgCreateDelegate
      let interest = ''
      if (type === 'gea.staking.MsgKycUsersTransferToNewRegion') {
        // 用户转区 奖励需要全部加起来
        interest =
          cardData?.msgs?.[0]?.extra_info?.detail?.users_transfer_to_new_region?.total_interest ||
          ''
        // const delegate_interest = cardData?.msgs?.[0]?.extra_info?.delegate_interest || ''
        // const kyc_interest = cardData?.msgs?.[0]?.extra_info?.kyc_interest || ''
        // const fixed_interest = cardData?.msgs?.[0]?.extra_info?.fixed_interest || ''
        // const lock_up_interest = cardData?.msgs?.[0]?.extra_info?.lock_up_interest || ''
        // const fields = ['delegate_interest', 'kyc_interest', 'fixed_interest', 'lock_up_interest']
        // const data = {
        //   delegate_interest,
        //   kyc_interest,
        //   fixed_interest,
        //   lock_up_interest,
        // }
        // interest = `${sumInterests(data, fields)}`
      } else if (type === 'gea.staking.MsgWithdrawFixedDelegation') {
        // AGS赎回奖励
        const delegate_interest = cardData?.msgs?.[0]?.extra_info?.delegate_interest || ''
        const fixed_interest = cardData?.msgs?.[0]?.extra_info?.fixed_interest || ''
        const fields = ['delegate_interest', 'fixed_interest']
        const data = {
          fixed_interest,
          delegate_interest,
        }
        interest = `${sumInterests(data, fields)}`
      } else {
        interest = cardData?.msgs?.[0]?.extra_info?.interest || ''
      }
      const childType = (
        <div
          className={classNames({
            [styles.redundantBox]: true,
            [styles.isHidden]: isFold,
          })}
        >
          {/* 提取区块奖励 */}
          <div className={classNames(styles.textStyleTwo, 'font_14')}>{t('explorer_234')}</div>
          {/* 提取区块奖励  */}
          <div className={classNames(styles.textStyleTwo, 'font_14')}>{t('explorer_234')}</div>
        </div>
      )
      const childAmount = (
        <div
          className={classNames({
            [styles.redundantBox]: true,
            [styles.isHidden]: isFold,
          })}
        >
          <div
            className={classNames(styles.textStyleTwo, 'font_14', {
              [styles.childType_height_nowrap_mobile]: false,
            })}
          >
            <span>{ugeaToGea2(interest).value}</span>{' '}
            <span className={classNames(styles.textStyleThree, 'font_14')}>
              {ugeaToGea2(interest).value !== '-' ? 'GEA' : ''}
            </span>
          </div>
          <div
            className={classNames(styles.textStyleTwo, 'font_14', {
              [styles.childType_height_nowrap_mobile]: false,
            })}
          >
            <span>{ugagToGag(interest).value}</span>{' '}
            <span className={classNames(styles.textStyleThree, 'font_14')}>
              {ugagToGag(interest).value !== '-' ? 'GAG' : ''}
            </span>
          </div>
        </div>
      )
      return {
        childType,
        isShowTypeSword: true,
        childAmount,
      }
    } else if (
      ['gea.staking.MsgWithdrawLockUpReward', 'gea.staking.MsgWithdrawDelegationInterest'].includes(
        type,
      )
    ) {
      // 提取活期奖励 gea.staking.MsgWithdrawDelegationInterest
      // AGE提取锁仓奖励 gea.staking.MsgWithdrawLockUpReward
      const childType = null
      const interest = cardData?.msgs?.[0]?.extra_info?.interest || ''
      const childAmount = (
        <div
          className={classNames({
            [styles.redundantBox]: true,
            [styles.isHidden]: isFold,
          })}
        >
          <div
            className={classNames(styles.textStyleTwo, 'font_14', {
              [styles.childType_height_nowrap_mobile]: true,
            })}
          >
            <span>{ugagToGag(interest).value}</span>{' '}
            <span className={classNames(styles.textStyleThree, 'font_14')}>GAG</span>
          </div>
        </div>
      )
      return {
        childType,
        isShowTypeSword: false,
        isShowAmountSword: true,
        childAmount,
      }
    }

    return emptyData
  }
  // # 更新KYC
  // const getDisplayChildValue = getDisplayChild('gea.kyc.MsgUpdate')
  // # 置换
  // const getDisplayChildValue = getDisplayChild('gea.staking.MsgSwap')
  // # AGS (CHN Node) 质押赎回（30）天
  // const getDisplayChildValue = getDisplayChild(' ')
  // AGD (CHN Node) 节点质押取回
  // const getDisplayChildValue = getDisplayChild('gea.staking.MsgUnDelegate')
  // AGE (CHN Node) 质押赎回
  // const getDisplayChildValue = getDisplayChild('gea.staking.MsgReduceLockUpDelegation')
  // 转区申请
  // const getDisplayChildValue = getDisplayChild('gea.staking.MsgTransferRegion')
  // 用户转区
  // const getDisplayChildValue = getDisplayChild('gea.staking.MsgKycUsersTransferToNewRegion')
  // 提取活期奖励
  // const getDisplayChildValue = getDisplayChild('gea.staking.MsgWithdrawDelegationInterest')
  // 提取锁仓奖励
  // const getDisplayChildValue = getDisplayChild('gea.staking.MsgWithdrawLockUpReward')
  //   AGE({{ regionId }} Node)质押提取锁仓奖励
  // const getDisplayChildValue = getDisplayChild('gea.staking.MsgCreateLockUpDelegate')
  const getDisplayChildValue = getDisplayChild(cardData?.msgs?.[0]?.type)

  const getAmount = (type: string | undefined) => {
    if (!type) {
      return ''
    }
    if (
      ![
        'gea.staking.MsgCreateDelegate', // AGD 质押(存入)
        'gea.kyc.MsgUpdate', // 更新kyc
        'gea.staking.MsgSwap', // 置换
        'gea.staking.MsgWithdrawFixedDelegation', // AGS质押赎回
        'gea.staking.MsgUnDelegate', //AGD ({{ regionId }} Node) 赎回
        'gea.staking.MsgReduceLockUpDelegation', // AGE ( {{ regionId }} Node)質押贖回
        'gea.staking.MsgTransferRegion', // 转区申请
        'gea.staking.MsgKycUsersTransferToNewRegion', // 用户转区
        'gea.staking.MsgWithdrawDelegationInterest', // 提取活期奖励
        'gea.staking.MsgWithdrawLockUpReward', // AGE ({{ regionId }} Node)提取锁仓奖励
        'gea.staking.MsgCreateLockUpDelegate', //gea.staking.MsgCreateLockUpDelegate
        'gea.staking.MsgCreateFixedDelegation', //AGS（{{ regionId }}  Node ）质押（{{ term }} 天）
        'gea.staking.MsgUpdateDelegatorAddress', //质押转移
      ].includes(type)
    ) {
      if (
        [
          'gea.bank.MsgModuleAccountSend',
          'cosmos.bank.v1beta1.MsgSend',
          'gea.staking.MsgWithdrawFromSwapPoo',
          'gea.staking.MsgDepositToInvitationRewardPool',
          'gea.staking.MsgWithdrawMintReward',
          'gea.staking.MsgTreasuryToSwapPool',
          'gea.staking.MsgDepositToSwapPool',
          'gea.staking.MsgWithdrawTreasury',
          'gea.staking.MsgWithdrawFromInvitationRewardPool',
          'gea.committee.MsgVote', // 投票
          'gea.committee.MsgVoteProposal',
        ].includes(type)
      ) {
        // 组装transfer_amount对象
        const ugag_coin_amount =
          cardData?.transfer_value?.find((item) => item.denom === 'ugag')?.amount || null
        const ugea_coin_amount =
          cardData?.transfer_value?.find((item) => item.denom === 'ugea')?.amount || null
        const transfer_amount = {
          aggregate: {
            sum: {
              ugag_coin_amount: ugag_coin_amount ? Number(ugag_coin_amount) : null,
              ugea_coin_amount: ugea_coin_amount ? Number(ugea_coin_amount) : null,
            },
          },
        }

        cardData.transfer_amount = transfer_amount
        // 如果GEA没有值
        if (isEmptyOrNil(cardData?.transfer_amount?.aggregate?.sum?.ugea_coin_amount)) {
          // 取GAG
          if (amountUnit !== 'GAG') {
            setAmountUnit('GAG')
          }
          return cardData?.transfer_amount?.aggregate?.sum?.ugag_coin_amount
        }
        // 如果GEA有值且等于0，查看GAG是否有值
        if (
          cardData?.transfer_amount?.aggregate?.sum?.ugea_coin_amount === 0 &&
          !isEmptyOrNil(cardData?.transfer_amount?.aggregate?.sum?.ugag_coin_amount)
        ) {
          if (amountUnit !== 'GAG') {
            setAmountUnit('GAG')
          }
          return cardData?.transfer_amount?.aggregate?.sum?.ugag_coin_amount
        }
        return cardData?.transfer_amount?.aggregate?.sum?.ugea_coin_amount
      }
      const ugea_coin_amount =
        cardData?.transfer_value?.find((item) => item.denom === 'ugea')?.amount || null
      return ugea_coin_amount
      // return cardData?.transfer_amount?.aggregate?.sum?.ugea_coin_amount
    }
    // gea.kyc.MsgUpdate 更新kyc
    // gea.staking.MsgSwap 置换
    if (['gea.kyc.MsgUpdate', 'gea.staking.MsgSwap'].includes(type)) {
      return ''
    }
    //  gea.staking.MsgTransferRegion 转区申请
    // gea.staking.MsgKycUsersTransferToNewRegion 用户转区
    if (
      ['gea.staking.MsgKycUsersTransferToNewRegion', 'gea.staking.MsgTransferRegion'].includes(type)
    ) {
      if (type === 'gea.staking.MsgKycUsersTransferToNewRegion') {
        const kyc_amount =
          cardData?.msgs?.[0]?.extra_info?.detail?.users_transfer_to_new_region?.kyc_reward || ''
        const lockup_amount =
          cardData?.msgs?.[0]?.extra_info?.detail?.users_transfer_to_new_region
            ?.total_lock_up_amount || ''
        if (isEmptyOrNil(kyc_amount) && isEmptyOrNil(lockup_amount)) {
          return ''
        }
        const fields = ['kyc_amount', 'lockup_amount']
        const data = {
          kyc_amount,
          lockup_amount,
        }
        return sumInterests(data, fields)
      }
      return cardData?.msgs?.[0]?.extra_info?.kyc_amount || ''
    }
    if (
      // 提取活期奖励 gea.staking.MsgWithdrawDelegationInterest
      // AGE提取锁仓奖励 gea.staking.MsgWithdrawLockUpReward
      ['gea.staking.MsgWithdrawDelegationInterest', 'gea.staking.MsgWithdrawLockUpReward'].includes(
        type,
      )
    ) {
      // 提取活期奖励
      return cardData?.msgs?.[0]?.extra_info?.interest || ''
    }
    // 质押转移
    if (type === 'gea.staking.MsgUpdateDelegatorAddress') {
      const {
        fixed_amount = '0',
        lock_up_amount = '0',
        delegation_amount = '0',
      } = (cardData?.msgs?.[0]?.extra_info as any) || {}
      const fields = ['fixed_amount', 'lock_up_amount', 'delegation_amount']
      const data = {
        fixed_amount,
        lock_up_amount,
        delegation_amount,
      }
      return sumInterests(data, fields)
    }

    return cardData?.msgs?.[0]?.extra_info?.amount || ''
  }
  const amount = getAmount(cardData?.msgs?.[0]?.type)
  const params = useParams()
  const handleJump = useCallback(() => {
    if (params.address) {
      navigate(`/transaction/${cardData.hash}?address=${params.address}`)
    } else {
      navigate(`/transaction/${cardData.hash}`)
    }
  }, [cardData])

  useEffect(() => {
    if (typeElement.current) {
      const observer = new IntersectionObserver((entries) => {
        setAmountHeight(entries[0].boundingClientRect.height)
      })
      observer.observe(typeElement.current)
    }
  }, [typeElement])

  const msgLength = useMemo(() => {
    return cardData?.msgs?.length || 0
  }, [cardData])
  return (
    <div className={styles.block_tx_wrap}>
      <div className="block_tx_area_a">
        <div className={styles.title}>hash</div>
        <div
          className={classNames({
            [styles.textStyleOne]: true,
            font_14: true,
          })}
        >
          <AddressHash data={cardData?.hash} cutOption handleJump={handleJump}></AddressHash>
        </div>
      </div>

      <div className="block_tx_area_b">
        {/* 状态 */}
        <div className={styles.title}>{t('explorer_53')}</div>
        <div
          className={classNames({
            [styles.textStyleTwo]: true,
            font_14: true,
          })}
        >
          <span>{cardData?.success ? t('explorer_25') : t('explorer_222')}</span>
          <span
            className={classNames({
              [styles.successIcon]: cardData?.success,
              [styles.failedIcon]: !cardData?.success,
            })}
          ></span>
        </div>
      </div>
      <div className="block_tx_area_c">
        {/* 类型 */}
        <div className={styles.title}>{t('explorer_104')}</div>

        <div
          className={classNames({
            [styles.textStyleTwo]: true,
            font_14: true,
          })}
          ref={typeElement}
        >
          <span className={styles.typeName}>
            {pageTitleFormat}
            {msgLength > 1 && <span style={{ marginLeft: '3px' }}>({'+' + msgLength})</span>}
          </span>
          {getDisplayChildValue?.isShowTypeSword && pageTitleFormat !== '-' && (
            <span onClick={handleSetIsFold}>
              <img src={Img_right} alt="" />
            </span>
          )}
        </div>
        {getDisplayChildValue?.childType}
      </div>

      <div className="block_tx_area_d">
        {/* 数量 */}
        <div className={styles.title}>{t('explorer_105')}</div>
        {pageTitleFormat !== '-' ? (
          <>
            <div
              className={classNames({
                [styles.textStyleTwo]: true,
                [styles.amount]: true,
                font_14: true,
              })}
              style={{ height: `${amountHeight}px` }}
            >
              {/* <span>0.01228792</span> <span className={styles.textStyleThree}>GEA</span> */}
              <span>
                {amountUnit === 'GEA' ? ugeaToGea2(amount).value : ugagToGag(amount).value}
              </span>
              <span
                className={classNames({
                  [styles.textStyleThree]: true,
                  font_14: true,
                })}
              >
                {amountUnit === 'GEA' ? ugeaToGea2(amount).sigin : ugagToGag(amount).sigin}
              </span>
              {getDisplayChildValue?.isShowAmountSword && pageTitleFormat !== '-' && (
                <span onClick={handleSetIsFold}>
                  <img src={Img_right} alt="" />
                </span>
              )}
            </div>
          </>
        ) : (
          '-'
        )}

        {getDisplayChildValue?.childAmount}
      </div>
      <div className="block_tx_area_e">
        <div className={styles.title}>GasFee</div>
        <div
          className={classNames({
            [styles.textStyleTwo]: true,
            font_14: true,
          })}
        >
          {pageTitleFormat !== '-' ? (
            <>
              <span>{ugeaToGea3(cardData?.gas_fee?.amount, cardData?.gas_fee?.denom).value}</span>{' '}
              <span
                className={classNames({
                  [styles.textStyleThree]: true,
                  font_14: true,
                })}
              >
                {ugeaToGea3(cardData?.gas_fee?.amount, cardData?.gas_fee?.denom).sigin}
              </span>
            </>
          ) : (
            '-'
          )}
        </div>
      </div>
    </div>
  )
}

export default TransactionListCardInfo
